import { PhosphorCheckCircle, PhosphorWarningCircle } from "components/Atoms/PhosphorIcon";
import SmallDetails from "components/SmallDetails/SmallDetails";
import React from "react";

interface Props {
  compliance: server.dto.CompanyCanReceivePeppol;
}

const error: server.dto.CompanyCanReceivePeppolCompliances[] = [
  "countryNotSupported",
  "companyInformationMissing",
];

const warning: server.dto.CompanyCanReceivePeppolCompliances[] = [
  "notFoundOnPeppol"
];

const success: server.dto.CompanyCanReceivePeppolCompliances[] = [
  "foundOnPeppol",
];

export const CompanyCanReceivePeppol = (props: Props) => {

  if (!props.compliance) {
    return null;
  }

  return <div className="flex gap">
    {error.includes(props.compliance.value) && <PhosphorWarningCircle
      iconSize="large"
      iconWeight="fill"
      iconColor="error"
    />}

    {warning.includes(props.compliance.value) && <PhosphorWarningCircle
      iconSize="large"
      iconWeight="fill"
      iconColor="yellow"
    />}

    {success.includes(props.compliance.value) && <PhosphorCheckCircle
      iconSize="large"
      iconWeight="fill"
      iconColor="green" />}
    <div>
      <SmallDetails
        label={props.compliance.message}
        subLabel={props.compliance.messageSublabel}
      />
    </div>
  </div>
}